import React from "react";
import styles from "./styles.css";

const CdpNextSteps = () => {
    return (
        <div styleName={"styles.outer"}>
            <p className="header" styleName={"styles.heading"}>Next steps:</p>
            <div className="media" styleName={"styles.stepWrap"}>
                <p styleName={"styles.stepCount"}>1</p>
                <div className="media-body">
                    <p styleName={"styles.steps"}>Enter your car condition during checkout to get the final trade-in valuation.</p>
                </div>
            </div>
            <div className="media" styleName={"styles.stepWrap"}>
                <p styleName={"styles.stepCount"}>2</p>
                <div className="media-body">
                    <p styleName={"styles.steps"}>Final trade-in valuation will be adjusted against your car purchase</p>
                </div>
            </div>
        </div>
    );
};

export default CdpNextSteps;
